import type { ChangeEvent } from 'react';

import { cn } from '~/lib/cn';

export interface InputProps<T> {
  value: T;
  onChange: (value: T) => void;
  type?: 'text' | 'number';
  placeholder?: string;
  className?: string;
  isReadonly?: boolean;
  max?: string;
}

// TODO: add prefixed and suffixed icons, like for search input
const Input = <T extends string | number>(
  props: InputProps<T>,
): JSX.Element => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    if (props.isReadonly) {
      return;
    }

    let newValue =
      props.type === 'number'
        ? (parseFloat(event.target.value) as T)
        : (event.target.value as T);

    if (props.type === 'number' && props.max) {
      newValue = (
        Number(newValue) > Number(props.max) ? props.max : newValue
      ) as T;
    }

    props.onChange(newValue);
  };

  return (
    <input
      className={cn(
        'h-[3em] w-full rounded-sm border px-md text-body-sm bg-emphasis-default border-emphasis-subtle focus:outline-none',
        props.className,
      )}
      max={props.max}
      onChange={handleChange}
      placeholder={props.placeholder}
      readOnly={props.isReadonly}
      type={props.type}
      value={props.value}
    />
  );
};

Input.displayName = 'Input';

export { Input };
